<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-form ref="portalConfigurationFormRef">
        <div v-if="portalConfigurationModel.is_accor != null">
          <v-card class="pa-0" flat>
            <v-card-text class="py-0">
              <v-switch
                :disabled="isInherit || isBuiltIn || !isGrantedUser()"
                v-model="parentPortalConfiguration.is_luxury"
                dense
                label="Portail Luxury"
              ></v-switch>
            </v-card-text>
          </v-card>
          <v-card class="pa-0" flat>
            <v-card-text class="py-0">
              <v-select
                :disabled="isInherit || isBuiltIn || !isGrantedUser()"
                v-model="parentPortalConfiguration.brand_newsletter"
                :items="brandNewsletters"
                item-value="value"
                item-text="text"
                label="Marque Newsletter"
              ></v-select>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
        </div>
        <v-card class="pa-0" flat>
          <v-card-title>Afficher saisie des codes</v-card-title>
          <v-card-text class="py-0">
            <v-radio-group
              row
              v-if="portalConfigurationModel.has_hide_access_codes"
              v-model="parentPortalConfiguration.hide_access_codes"
            >
              <v-radio
                label="Afficher ouvert"
                :value="0"
                :disabled="isInherit || isBuiltIn || !isGrantedUser()"
              ></v-radio>
              <v-radio
                label="Ne pas afficher"
                :value="1"
                :disabled="
                  parentPortalConfiguration.has_card_at_reception ||
                  isFullCb ||
                  isBasicCb ||
                  isInherit ||
                  isBuiltIn ||
                  !isGrantedUser()
                "
              ></v-radio>
              <v-radio
                label="Afficher fermé"
                :value="2"
                :disabled="isInherit || isBuiltIn || !isGrantedUser()"
              ></v-radio>
            </v-radio-group>
            <div class="inline-block mr-4">
              <v-checkbox
                label="Carte à réception"
                v-if="portalConfigurationModel.has_card_at_reception"
                v-model="parentPortalConfiguration.has_card_at_reception"
                :disabled="isInherit || isBuiltIn || !isGrantedUser()"
              ></v-checkbox>
            </div>
            <div class="inline-block mr-4">
              <v-checkbox
                label="PMS Santé"
                v-if="portalConfigurationModel.has_pms_marseo"
                v-model="parentPortalConfiguration.has_pms_marseo"
                :disabled="isInherit || isBuiltIn || !isGrantedUser()"
              ></v-checkbox>
            </div>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-title>
            <v-checkbox
              class="mt-0 pt-0"
              dense
              v-model="hasBasicPresentation"
              :disabled="isInherit || isBuiltIn || !isGrantedUser()"
              hide-details
            ></v-checkbox>
            Présentation Basic
          </v-card-title>
          <v-card-subtitle
            class="red--text"
            v-if="hasBasicPresentation && !hasFullPresentation"
          >
            Avec une présensation Basic, une présentation Full est également
            obligatoire
          </v-card-subtitle>
          <v-card-subtitle class="red--text" v-if="!isBasicPresentationValid">
            Vous devez sélectionner le mode de connexion BASIC ci-dessous
          </v-card-subtitle>

          <v-card-text class="py-0">
            <v-radio-group
              v-model="parentPortalConfiguration.basic_presentation.payment"
            >
              <template
                v-for="(payment, index) in portalConfigurationModel
                  .basic_presentation.payment"
              >
                <div :key="index">
                  <v-radio
                    :label="capitalize(payment)"
                    :value="payment"
                    :disabled="
                      !hasBasicPresentation ||
                      isInherit ||
                      isBuiltIn ||
                      !isGrantedUser()
                    "
                    class="mb-0"
                  ></v-radio>
                  <div class="pl-3 mb-3">
                    <template v-if="payment == 'free'">
                      <template
                        v-for="(access, indexAccess) in portalConfigurationModel
                          .basic_presentation.free_access"
                      >
                        <div class="inline-block mr-2" :key="indexAccess">
                          <v-checkbox
                            :key="access"
                            v-model="
                              parentPortalConfiguration.basic_presentation
                                .access
                            "
                            :label="capitalize(access)"
                            :value="access"
                            :disabled="
                              !hasBasicPresentation ||
                              parentPortalConfiguration.basic_presentation
                                .payment != 'free' ||
                              isInherit ||
                              isBuiltIn ||
                              isBasicClickToConnectChecked(access) ||
                              !isGrantedUser()
                            "
                          ></v-checkbox>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <v-radio-group
                        row
                        v-model="
                          parentPortalConfiguration.basic_presentation.access
                        "
                      >
                        <v-radio
                          :key="access"
                          v-for="access in portalConfigurationModel
                            .basic_presentation.chargeable_access"
                          :label="capitalize(access)"
                          :value="access"
                          :disabled="
                            !hasBasicPresentation ||
                            parentPortalConfiguration.basic_presentation
                              .payment != 'chargeable' ||
                            isInherit ||
                            isBuiltIn ||
                            !isGrantedUser()
                          "
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </div>
                </div>
              </template>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-title>
            <v-checkbox
              class="mt-0 pt-0"
              hide-details
              dense
              v-model="hasFullPresentation"
              :disabled="isInherit || isBuiltIn || !isGrantedUser()"
            ></v-checkbox>
            Présentation Full
          </v-card-title>
          <v-card-subtitle class="red--text" v-if="!isFullPresentationValid">
            Vous devez sélectionner le mode de connexion FULL ci-dessous
          </v-card-subtitle>

          <v-card-text class="py-0">
            <v-radio-group
              v-model="parentPortalConfiguration.full_presentation.payment"
            >
              <template
                v-for="(payment, index) in portalConfigurationModel
                  .full_presentation.payment"
              >
                <div :key="index">
                  <v-radio
                    :label="capitalize(payment)"
                    :value="payment"
                    :disabled="
                      !hasFullPresentation ||
                      isInherit ||
                      isBuiltIn ||
                      !isGrantedUser()
                    "
                    class="mb-0"
                  ></v-radio>
                  <div class="pl-3 mb-3">
                    <template v-if="payment == 'free'">
                      <template
                        v-for="(access, indexAccess) in portalConfigurationModel
                          .full_presentation.free_access"
                      >
                        <div class="inline-block mr-4" :key="indexAccess">
                          <v-checkbox
                            @change="updateFullPresentationAccess($event)"
                            :key="access"
                            v-model="
                              parentPortalConfiguration.full_presentation.access
                            "
                            :label="capitalize(access)"
                            :value="access"
                            :disabled="
                              !hasFullPresentation ||
                              parentPortalConfiguration.full_presentation
                                .payment != 'free' ||
                              isInherit ||
                              isBuiltIn ||
                              isFullClickToConnectChecked(access) ||
                              !isGrantedUser()
                            "
                          ></v-checkbox>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <v-radio-group
                        row
                        v-model="
                          parentPortalConfiguration.full_presentation.access
                        "
                      >
                        <v-radio
                          :key="access"
                          v-for="access in portalConfigurationModel
                            .full_presentation.chargeable_access"
                          :label="capitalize(access)"
                          :value="access"
                          :disabled="
                            !hasFullPresentation ||
                            parentPortalConfiguration.full_presentation
                              .payment != 'chargeable' ||
                            isInherit ||
                            isBuiltIn ||
                            !isGrantedUser()
                          "
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </div>
                </div>
              </template>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat class="pb-2">
          <v-card-title> Champs formulaire </v-card-title>
          <v-card-text class="py-0">
            <template
              v-for="(field, indexField) in portalConfigurationModel.user_form"
            >
              <div class="inline-block mr-4" :key="indexField">
                <v-checkbox
                  v-if="field == 'email'"
                  v-model="parentPortalConfiguration.user_form"
                  :label="field"
                  :value="field"
                  :disabled="
                    isInherit ||
                    isBuiltIn ||
                    !isGrantedUser() ||
                    isUserFormDisabled
                  "
                ></v-checkbox>
                <v-checkbox
                  v-else
                  v-model="parentPortalConfiguration.user_form"
                  :label="field"
                  :value="field"
                  :disabled="
                    isInherit ||
                    isBuiltIn ||
                    !isGrantedUser ||
                    isUserFormDisabled
                  "
                ></v-checkbox>
              </div>
            </template>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card
          flat
          v-if="
            portalConfigurationModel.has_ad != null &&
            parentPortalConfiguration.ad != null
          "
        >
          <v-card-title>Publicité</v-card-title>
          <v-card-text class="py-0">
            <v-checkbox
              v-model="parentPortalConfiguration.ad.is_active"
              label="Activer la publicité"
              :disabled="isInherit || isBuiltIn || !isGrantedUser()"
            ></v-checkbox>
            <v-text-field
              label="Groupname"
              v-model="parentPortalConfiguration.ad.groupname"
              :disabled="
                !parentPortalConfiguration.ad.is_active ||
                isBuiltIn ||
                !isGrantedUser()
              "
            ></v-text-field>
            <v-text-field
              label="Country"
              v-model="parentPortalConfiguration.ad.country"
              :disabled="
                !parentPortalConfiguration.ad.is_active ||
                isBuiltIn ||
                !isGrantedUser()
              "
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>

    <v-col cols="6" class="pa-0">
      <v-btn
        block
        depressed
        tile
        @click.stop="cancelData"
        :disabled="!hasChanges"
      >
        Annuler
      </v-btn>
    </v-col>
    <v-col cols="6" class="pa-0">
      <v-btn
        v-if="isGrantedUser()"
        block
        depressed
        tile
        color="primary"
        @click="sendUpdatePortalSettings"
        :loading="loadingSettingsPortal"
        :disabled="
          isInherit ||
          isBuiltIn ||
          !isBasicPresentationValid ||
          !isFullPresentationValid ||
          !hasChanges
        "
      >
        <span v-if="!isInherit && !isBuiltIn"> Enregistrer </span>
        <span v-else-if="isInherit"> Portail en héritage </span>
        <span v-else-if="isBuiltIn"> Portail en modèle prédéfini </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { watch, onMounted, computed, ref } from "@vue/composition-api";
import { usePortalConfiguration } from "@/composables/portal-configuration";
import { useRoles } from "../../composables/roles";
import { cloneDeep, isEmpty } from "lodash";
import Vue from "vue";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    isGroup: Boolean,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    rules: Object,
    loadingSettingsPortal: Boolean,
  },
  setup(props, { emit }) {
    /* Import des PAI */
    const {
      initConfigurationForm,
      portalConfigurationFormRef,
      portalProfile,
      hasBasicPresentation,
      hasFullPresentation,
      brandNewsletters,
    } = usePortalConfiguration();
    const { isGrantedUser } = useRoles();

    const parentPortalConfiguration = initConfigurationForm(props);

    let origPortalConfig = cloneDeep(parentPortalConfiguration);
    const hasChanges = ref(false);

    const cancelData = async () => {
      const fullCopy = cloneDeep(origPortalConfig);
      Object.assign(parentPortalConfiguration, fullCopy);
      await Vue.nextTick();
      // trick to force the cancel at intital state && handle the watcher side effect (watcher are also defined in portal-configuration.js like parentPortalConfiguration.basic_presentation.payment && parentPortalConfiguration.full_presentation.payment)
      const fullCopyForce = cloneDeep(origPortalConfig);
      Object.assign(parentPortalConfiguration, fullCopyForce);

      // second trick to apply this value ONLY after watchers execution (parentPortalConfiguration)
      Vue.nextTick(() => {
        hasChanges.value = false;
      });
    };

    const sendUpdatePortalSettings = function () {
      hasChanges.value = false;
      origPortalConfig = cloneDeep(parentPortalConfiguration);
      emit("update:portal-settings");
    };

    /* Computed */
    const isFullCb = computed(function () {
      return (
        hasFullPresentation.value &&
        parentPortalConfiguration.full_presentation.access != undefined &&
        parentPortalConfiguration.full_presentation.access.indexOf("cb") > -1
      );
    });
    const isBasicCb = computed(function () {
      return (
        hasBasicPresentation.value &&
        parentPortalConfiguration.basic_presentation.access != undefined &&
        parentPortalConfiguration.basic_presentation.access.indexOf("cb") > -1
      );
    });

    const isUserFormDisabled = computed(() => {
      if (
        (parentPortalConfiguration.basic_presentation != null &&
          parentPortalConfiguration.basic_presentation.access != undefined &&
          (parentPortalConfiguration.basic_presentation.access.includes("cb") ||
            parentPortalConfiguration.basic_presentation.access.includes(
              "pms"
            ) ||
            parentPortalConfiguration.basic_presentation.access.includes(
              "form"
            ))) ||
        (parentPortalConfiguration.full_presentation != null &&
          parentPortalConfiguration.full_presentation.access != undefined &&
          (parentPortalConfiguration.full_presentation.access.includes("cb") ||
            parentPortalConfiguration.full_presentation.access.includes(
              "pms"
            ) ||
            parentPortalConfiguration.full_presentation.access.includes(
              "form"
            )))
      ) {
        return false;
      }
      return true;
    });

    // email field is also disabled in free mode with access "form"
    const isEmailUserFormDisabled = computed(() => {
      if (
        (parentPortalConfiguration.basic_presentation != null &&
          parentPortalConfiguration.basic_presentation.access != undefined &&
          parentPortalConfiguration.basic_presentation.access.includes(
            "form"
          )) ||
        (parentPortalConfiguration.full_presentation != null &&
          parentPortalConfiguration.full_presentation.access != undefined &&
          parentPortalConfiguration.full_presentation.access.includes("form"))
      ) {
        return true;
      }
      return false;
    });

    const isBasicPresentationValid = computed(() => {
      if (hasBasicPresentation.value) {
        if (
          parentPortalConfiguration.basic_presentation == null ||
          parentPortalConfiguration.basic_presentation.payment == null ||
          isEmpty(parentPortalConfiguration.basic_presentation.access)
        ) {
          return false;
        }
      }

      return true;
    });

    const isFullPresentationValid = computed(() => {
      if (hasBasicPresentation.value) {
        if (
          parentPortalConfiguration.full_presentation == null ||
          parentPortalConfiguration.full_presentation.payment == null ||
          isEmpty(parentPortalConfiguration.full_presentation.access)
        ) {
          return false;
        }
      }

      return true;
    });

    /* Cycle de vie */
    onMounted(() => {
      emit("mounted");
      if (props.portalConfigurationModel.has_hide_access_codes) {
        if (
          hasFullPresentation.value &&
          parentPortalConfiguration.full_presentation.payment == "free"
        ) {
          parentPortalConfiguration.hide_access_codes = 1;
        } else if (
          parentPortalConfiguration.has_card_at_reception ||
          isFullCb.value ||
          isBasicCb.value
        ) {
          parentPortalConfiguration.hide_access_codes = 0;
        }
      }

      Vue.nextTick(() => {
        hasChanges.value = false;
      });
    });

    const updateFullPresentationAccess = (event) => {
      // if we are in full clickToConnect, and basic is empty => disable card at reception

      if (event.length == 1 && event[0] == "clickToConnect") {
        if (
          parentPortalConfiguration.full_presentation.access != undefined &&
          parentPortalConfiguration.full_presentation.access.indexOf(
            "clickToConnect"
          ) > -1 &&
          (parentPortalConfiguration.basic_presentation.access == undefined ||
            parentPortalConfiguration.basic_presentation.access.length < 1)
        ) {
          parentPortalConfiguration.hide_access_codes = 1;
          parentPortalConfiguration.has_card_at_reception = false;
        }
      }
    };

    /* Watchers */
    watch(
      () => parentPortalConfiguration.basic_presentation.access,
      function (newValue, oldValue) {
        if (newValue != null && newValue.length > 0) {
          hasBasicPresentation.value = true;
        }
        if (
          newValue != oldValue &&
          newValue != null &&
          newValue.length > 1 &&
          newValue.includes("clickToConnect")
        ) {
          parentPortalConfiguration.basic_presentation.access = [
            "clickToConnect",
          ];
        }
        if (
          parentPortalConfiguration.basic_presentation.access != undefined &&
          parentPortalConfiguration.basic_presentation.access.indexOf("form") >
            -1 &&
          parentPortalConfiguration.user_form != undefined &&
          parentPortalConfiguration.user_form.indexOf("email") < 0
        ) {
          parentPortalConfiguration.user_form.push("email");
        }
      }
    );
    watch(
      () => parentPortalConfiguration.full_presentation.access,
      function (newValue, oldValue) {
        if (newValue != null && newValue.length > 0) {
          hasFullPresentation.value = true;
        }
        if (
          newValue != oldValue &&
          newValue != null &&
          newValue.length > 1 &&
          newValue.includes("clickToConnect")
        ) {
          parentPortalConfiguration.full_presentation.access = [
            "clickToConnect",
          ];
        }
        if (
          parentPortalConfiguration.full_presentation.access != undefined &&
          parentPortalConfiguration.full_presentation.access.indexOf("form") >
            -1 &&
          parentPortalConfiguration.user_form != undefined &&
          parentPortalConfiguration.user_form.indexOf("email") < 0
        ) {
          parentPortalConfiguration.user_form.push("email");
        }
      }
    );
    watch(
      () => parentPortalConfiguration,
      (newValue) => {
        hasChanges.value = true;
        emit("update:portalConfiguration", newValue);
      },
      { deep: true }
    );
    watch(
      () => [
        parentPortalConfiguration.has_card_at_reception,
        isFullCb.value,
        isBasicCb.value,
        props.isInherit,
        props.isBuiltIn,
      ],
      () => {
        if (
          parentPortalConfiguration.has_card_at_reception ||
          isFullCb.value ||
          isBasicCb.value ||
          props.isInherit ||
          props.isBuiltIn
        ) {
          parentPortalConfiguration.hide_access_codes = 0;
        }
      },
      { deep: true }
    );

    /* Méthodes */
    const capitalize = function (str) {
      return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
    };

    const isBasicClickToConnectChecked = (access) => {
      if (
        access != "clickToConnect" &&
        parentPortalConfiguration.basic_presentation.access.includes(
          "clickToConnect"
        )
      ) {
        return true;
      }
      return false;
    };

    const isFullClickToConnectChecked = (access) => {
      if (
        access != "clickToConnect" &&
        parentPortalConfiguration.full_presentation.access.includes(
          "clickToConnect"
        )
      ) {
        return true;
      }
      return false;
    };

    return {
      brandNewsletters,
      hasBasicPresentation,
      hasFullPresentation,
      parentPortalConfiguration,
      portalProfile,
      portalConfigurationFormRef,
      capitalize,
      isFullCb,
      isBasicCb,
      updateFullPresentationAccess,
      isBasicClickToConnectChecked,
      isFullClickToConnectChecked,
      isGrantedUser,
      isUserFormDisabled,
      isEmailUserFormDisabled,
      isBasicPresentationValid,
      isFullPresentationValid,
      sendUpdatePortalSettings,
      cancelData,
      hasChanges,
    };
  },
};
</script>
